import { ColumnDef } from './column-def';

export type CellClick<T> = { item: T, columnDef: ColumnDef<T> };
